<div class="container">
    <div class="col-md-12 mb-2 empl-tptxt">
        <h3> Knowledge Bank </h3>
    </div>
    <div class="row row-cols-2 row-cols-lg-3 g-2 g-lg-3 mx-0 mt-0"
        *ngIf="knowledgeQuickSelectList$ | async as knowledgeTitle">
        <div *ngFor="let title of knowledgeTitle.content">
            <div class="miangbdpg-boxxcont">
                <div class="col">
                    <div class="p-5">
                        <div class="empl-tptxt link" (click)="viewArticle(title.id)">
                            <h3>{{ title.heading }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="miangbdpg-boxxcont">
                <div class="col">
                    <div class="p-5">
                        <div class="empl-tptxt link">
                            <h3>New Joinee Workflow</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col">
            <div class="miangbdpg-boxxcont">
                <div class="col">
                    <div class="p-5">
                        <div class="empl-tptxt link" (click)="viewAllArticle()">
                            <h3>View All</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 my-3 text-end align-self-end mt-3">
            <button type="button" class="btngbdpg-viwall" (click)="back()">Back</button>
        </div>
    </div>
</div>